enum ErrorSuggestions {
	COMMAND_TYPE_NOT_VALID = 'Allowed characters are: a-z, A-Z, 0-9, ., -, _',
	VIDEO_WAS_NOT_PLAYED = 'Play the video first.',
	// eslint-disable-next-line @typescript-eslint/prefer-literal-enum-member
	VIDEO_WAS_STOPPED_ALREADY = 'Ignore the rejection if you stop video on demand. ' +
		"Video could never end because it is stopped before it's end. " +
		"If you'd like to continue video to it's end, you probably looking for pause/resume methods.",
	SECURITY_PIN_CODE_FORMAT = 'PIN code has to be 4 digits string. E.g.: 1234',
}

export default ErrorSuggestions;
